import { render, staticRenderFns } from "./ImgInicio.vue?vue&type=template&id=147aac08&scoped=true"
import script from "./ImgInicio.vue?vue&type=script&lang=js"
export * from "./ImgInicio.vue?vue&type=script&lang=js"
import style0 from "./ImgInicio.vue?vue&type=style&index=0&id=147aac08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147aac08",
  null
  
)

export default component.exports